module.exports = __webpack_public_path__ + "banquet/components/StoreAboutPage/images/about_phone_3x.be50df4b968db499942ef14947e06167.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreAboutPage/images/about_phone_3x.png
// module id = 1693
// module chunks = 1